import { Envelope } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";
import { Link } from "react-router-dom";

import { MessageLeadDialog } from "common/components/leads/index";
import { Button } from "common/components/ui/Button";
import Skeleton from "common/components/ui/Skeleton";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { DetailedLead } from "common/types";

export default function MessageLeadButton({
  lead,
  isLoading,
  size,
}: {
  lead: DetailedLead;
  isLoading: boolean;
  size: "sm" | "md";
}) {
  const { id } = useSelectedWorkspaceContext();
  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);

  if (isLoading) {
    return (
      <Skeleton
        className={clsx("flex-1 rounded-full", size === "md" ? "h-10" : "h-8")}
      />
    );
  }

  const messageLeadButtonProps = {
    className: "flex-1",
    leftIcon: <Envelope weight="fill" />,
    size,
  };
  if (lead.lead_of.length > 1) {
    return (
      <>
        <Button
          {...messageLeadButtonProps}
          onClick={() => setIsMessageDialogOpen(true)}
        >
          Send message
        </Button>
        <MessageLeadDialog
          lead={lead}
          isOpen={isMessageDialogOpen}
          onClose={() => setIsMessageDialogOpen(false)}
        />
      </>
    );
  }
  return (
    <Button asChild {...messageLeadButtonProps}>
      <Link to={`/workspaces/${id}/inbox`} state={{ lead }}>
        Send message
      </Link>
    </Button>
  );
}
